import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/sp.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "border-top": "10px solid #f1f1f1"
  }
}, null, -1);
const _hoisted_2 = {
  class: "titleone"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = ["src", "onClick"];
const _hoisted_5 = {
  class: "titleone"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "30px",
    "height": "30px",
    "opacity": "0.8",
    "position": "relative",
    "top": "-58px",
    "left": "24px"
  }
}, null, -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "block"
})], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_tabs, {
    active: _ctx.active,
    "onUpdate:active": _cache[0] || (_cache[0] = $event => _ctx.active = $event),
    color: "#fdd100",
    style: {
      "padding-top": "20px"
    }
  }, {
    default: _withCtx(() => [_hoisted_1, _createVNode(_component_van_tab, {
      title: $setup.ImgCount
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.home_pics, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "index-box",
          key: item
        }, [_createElementVNode("div", _hoisted_2, _toDisplayString(item.OneLevel), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.DetailList, T => {
          return _openBlock(), _createElementBlock("div", {
            key: T
          }, [_createElementVNode("div", _hoisted_3, _toDisplayString(T.TwoLevel), 1), _createVNode(_component_van_row, {
            gutter: "20"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(T.ImgList, P => {
              return _openBlock(), _createBlock(_component_van_col, {
                span: "6",
                key: P
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: P.C_Url,
                  onClick: $event => $options.ImagePrediv(P.C_OriginalUrl),
                  style: {
                    "height": "80px"
                  }
                }, null, 8, _hoisted_4)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1024)]);
        }), 128))]);
      }), 128))]),
      _: 1
    }, 8, ["title"]), _createVNode(_component_van_tab, {
      title: $setup.VideoCount
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.home_videos, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "index-box",
          key: item
        }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.OneLevel), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.DetailList, T => {
          return _openBlock(), _createElementBlock("div", {
            key: T
          }, [_createElementVNode("div", _hoisted_6, _toDisplayString(T.TwoLevel), 1), _createVNode(_component_van_row, {
            gutter: "20"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(T.ImgList, P => {
              return _openBlock(), _createBlock(_component_van_col, {
                span: "6",
                key: P,
                onClick: $event => $options.playvideo(P.C_Url)
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: P.C_VideoImg,
                  style: {
                    "height": "80px"
                  }
                }, null, 8, _hoisted_7), _hoisted_8]),
                _: 2
              }, 1032, ["onClick"]);
            }), 128))]),
            _: 2
          }, 1024)]);
        }), 128))]);
      }), 128))]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["active"]), _createVNode(_component_van_overlay, {
    show: $setup.show,
    onClick: $options.closeoverlay
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }, 8, ["show", "onClick"])], 64);
}